function updateCopyrightYear() {
    const yearElement = document.querySelector('[data-sg-year]');
    if ( ! yearElement) return;

    const existingYear = parseInt(yearElement.textContent.trim(), 10);
    const currentYear = new Date().getFullYear();

    if (existingYear !== currentYear) {
        yearElement.textContent = currentYear;
    }
}

function init() {
    updateCopyrightYear();
}

export default {
    init
};
